export const tableHeaderColour = '#4d4f53';
export const filterBlue = '#7a80dd';
export const filterGrey = '#dcdcdc';
export const white = '#FFFFFF';
export const black = '#000000';
export const formControlColour = 'rgba(0, 0, 0, 0.54)';
export const tooltipColour = '#4d4f53';